export default __webpack_public_path__ + "static/media/Hewlett Packard Enterprise.196aaba2.png";